'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadHistories = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getThreadHistories = exports.getThreadHistories = (0, _get2.default)('threadHistories');


//////////////////
// WEBPACK FOOTER
// ./js/thread-histories/selectors/getThreadHistories.js
// module id = 581
// module chunks = 2 3